/* this component mainly exists so that you dont have to give every button a data-testid & classname if you dont want to*/
import * as React from "react";
import { useContext } from "react";
import { FormContext } from "./form-fields.tsx";

export interface ButtonProps {
  className?: string;
  noDisable?: boolean;
  manualDisable?: boolean;
  children?: React.ReactNode;
  //if both these attributes are defined you get an input type="button" instead of a button
  name?: string;
  value?: string;
}

// ⚠️ noDisable and manualDisable are confusing. can this be simplified?
export const FormButton: React.FC<ButtonProps> = ({
  className,
  noDisable = false,
  children,
  manualDisable,
  name,
  value,
}) => {
  const manager = useContext(FormContext)!;

  /*
  all this boilerplate is to add progressive enhancement to the --disabled class
  so that forms will work without js enabled
  */
  const makeCssClass = (inBrowser = false) => {
    let cssClass = "Button";
    if (className) cssClass += ` ${className}`;
    if (inBrowser) {
      if ((!manager.hasAllRequiredFields && !noDisable) || manualDisable) {
        cssClass += " --disabled";
      }
    }
    return cssClass;
  };

  const [cssClass, setCssClass] = React.useState(makeCssClass());

  React.useEffect(() => {
    setCssClass(makeCssClass(true));
  }, [manager.state, className, children, value, name, noDisable, manualDisable]);
  /* end of the above mentioned boilerplate */

  if (name && value) {
    return (
      <button
        data-testid="form-button"
        className={cssClass}
        name={name}
        value={value}
      >
        {children ? children : "Submit"}
      </button>
    );
  }

  return (
    <button
      data-testid="form-button"
      className={cssClass}
    >
      {children ? children : "Submit"}
    </button>
  );
};

export default FormButton;
